import React from 'react';
import { BuildingIcon, FileClockIcon, PackageIcon, NetworkIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { ScrollFadeIn } from './ScrollFadeIn';
const statusItems = [{
  key: 'status.item1',
  Icon: BuildingIcon
}, {
  key: 'status.item2',
  Icon: FileClockIcon
}, {
  key: 'status.item3',
  Icon: PackageIcon
}, {
  key: 'status.item4',
  Icon: NetworkIcon
}];
export function CompanyStatus() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-navy py-20 sm:py-28" data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <ScrollFadeIn data-id="element-62">
          <div className="mb-4" data-id="element-63">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-electric" data-id="element-64">
              {t('status.label')}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mb-12" data-id="element-65">
            {t('status.heading')}
          </h2>
        </ScrollFadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-66">
          {statusItems.map((item, i) => <ScrollFadeIn key={item.key} delay={i * 80} data-id="element-67">
              <div className="flex items-start gap-4 p-5 bg-graphite border border-slate-700/50 rounded h-full" data-id="element-68">
                <div className="shrink-0 w-9 h-9 flex items-center justify-center rounded bg-electric/10" data-id="element-69">
                  <item.Icon className="w-4 h-4 text-electric" data-id="element-70" />
                </div>
                <p className="text-sm text-slate-300 leading-relaxed" data-id="element-71">
                  {t(item.key)}
                </p>
              </div>
            </ScrollFadeIn>)}
        </div>
      </div>
    </section>;
}